import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import { StyledPageWrapper } from 'common/styles';
import { useCategory } from 'service/hooks';
import { useGlobalOrderTypeAndTime, usePersistedBranchId } from 'common/hooks';
import { LANGUAGE_AR } from 'common/constants';
import { handleScheduledTime } from 'modules/productsModule/utils';
import useTranslation from 'next-translate/useTranslation';
import FixedButton from 'modules/productsModule/components/FixedButton';
import Products from '../../components/Products/Products';
import { useShouldSortProductsByLang } from '../../hooks';

const StoreFrontHeaderComponent = dynamic(() => import('common/components/StoreFrontHeader'));

const CategoryPage = () => {
  const router = useRouter();
  const { lang } = useTranslation();
  const [branchId] = usePersistedBranchId();
  const [globalOrderTypeAndTime] = useGlobalOrderTypeAndTime();
  const { fulfillmentTimeType, scheduleSlotInterval } = globalOrderTypeAndTime || {};
  const scheduledTime = handleScheduledTime(fulfillmentTimeType, scheduleSlotInterval);

  const shouldSortProductsByLanguage = useShouldSortProductsByLang(lang);
  const { data: category, isLoading } = useCategory({
    scheduledTime,
    categoryId: router.query.id.toString(),
    branchId,
    lang: shouldSortProductsByLanguage ? lang : null,
  });

  const isArabic = router.locale === LANGUAGE_AR;
  const { titleAr, titleEn, products } = category || {};
  const title = isArabic ? titleAr : titleEn;

  return (
    <StyledPageWrapper>
      <StoreFrontHeaderComponent title={title} />
      <Products isLoading={isLoading} products={products} />
      <FixedButton />
    </StyledPageWrapper>
  );
};

export default CategoryPage;
